export const validate = () => {
  var errors = {};

  return [!Object.getOwnPropertyNames(errors).length, errors, errors.error];
};

export default validate;
